$(document).ready(function() {
	// priceSliderInit()
	adjustProductAmount()
	flashSaleCountdownInit()
	ajaxLinkClick()

	if($('.gremsy-landing-page-content').length > 0) {
		$('header').css({
			'background-color': '#00a0dd'
		})
	}

	if($('.compare-products-table').length > 0) {
		$('header').css({
			'background-color': '#00a0dd'
		})
	}

	if($('.wrap-confirmreg').length > 0) {
		$('header').css({
			'background-color': '#00a0dd'
		})
	}

	$(".product-tab-wrapper .tab-content").hide()

	$(".product-catalogue").each(function(){
		var color = $(this).css("color")
		$(this).find(".product .icon.hot").css({
			backgroundColor: color
		})
	})

	$(window).on('scroll', function () {
		$('header').toggleClass('scrolling', $(window).scrollTop() > 0)
		$('.back-to-top').toggleClass('active', $(window).scrollTop() > 0)
	})

	$('a[data-manual]').click(function(){
		var index = $(this).data('manual')
		$('a[data-manual]').parent().removeClass('active')
		$(this).parent().addClass('active')
		UIkit.accordion('.support-detail .list-item').toggle(index - 1, true)
	})

	$('.recruitment-detail .btn-apply').click(function(e) {
		e.preventDefault();
		$('.apply-form').slideToggle()
	})

	$.fancybox.defaults.parentEl = "form"

	if($(window).width() < 1025) {
		$('.sidenav .title').click(function(){
			$('.sidenav ul').slideToggle()
		})
	}

	if($('.user-sidemenu').length > 0) {
		$('header').addClass('non-fixed')
	}

	$('.mega-trigger').mouseenter(function(e){
		var index = $(this).data('index')
		$(".mega-item").removeClass('open')
		$(".mega-item[data-index='" + index + "']").addClass('open')
	})

	$('.banner img').attr('src', $('#NewsDetailBanner').attr('src'))

	$('.fixed-subscribe .subscribe-title').click(function(){
		$('.fixed-subscribe .subscribe-box').slideToggle()
	})

	if($('.form-popup').length > 0){
		$('.form-popup').append($('.form-popup-wrapper'))
	} else {
		$('.form-popup-wrapper').hide()
	}

	if($('#sold-out-form-container').length > 0) {
		$('#sold-out-form-container').append($('.sold-out-form'))
	}

	$('#sold-out-form-container .sold-out-product input').val($('.product-detail-info h1').text())

	$('.search a').click(function() {
		$('.uk-search-input').focus()
	})

	var arr360Src = [];
	$(".img-array img").each(function() {
		let src = $(this).attr("src");
		arr360Src.push(src);
	});
	try {
		$("#mySpriteSpin").spritespin({
			animate: true,
			responsive: true,
			reverse: true,
			width: 500,
			height: 500,
			frameTime: 100,
			// path to the source images.
			source: arr360Src
		});
	} catch (error) {}

	$('.wrap-form .form-group').each(function(){
		$(this).find('.fa-exclamation-triangle').on('DOMAttrModified', function(){
			console.log('abc');
			
		})
	})

});


var productLandingPageSmallImage = new Swiper('.product-landingpage-8 .small-image-slider .swiper-container', {
	slidesPerView: 6,
	spaceBetween: 10,
	observer: true,
	observeParents: true,
	breakpoints : {
		576: {
			slidesPerView: 3
		}
	}
})
var productLandingPageBigImage = new Swiper('.product-landingpage-8 .big-image-slider .swiper-container', {
	spaceBetween: 30,
	navigation: {
		prevEl: ".product-landingpage-8 .big-image-slider .swiper-prev",
		nextEl: ".product-landingpage-8 .big-image-slider .swiper-next"
	},
	observer: true,
	observeParents: true,
	thumbs: {
		swiper: productLandingPageSmallImage
	}
})

var productThumbnailSlider = new Swiper('.product-thumbnail-slider .swiper-container', {
	direction: 'vertical',
	slidesPerView: 4,
	spaceBetween: 10,
	observer: true,
	observeParents: true,
	navigation: {
		prevEl: ".product-thumbnail-slider  .swiper-prev",
		nextEl: ".product-thumbnail-slider  .swiper-next"
	},
	breakpoints: {
		768: {
			direction: 'horizontal'
		},
		576: {
			slidesPerView: 3,
			direction: 'horizontal',
		}
	}
})

var productImagesSlider = new Swiper('.product-image-slider .swiper-container', {
	spaceBetween: 10,
	observer: true,
	observeParents: true,
	thumbs: {
		swiper: productThumbnailSlider
	}
})

const menuMobileMapping = new MappingListener({
	selector: ".menu-wrapper",
	mobileWrapper: ".mobile-menu",
	mobileMethod: "appendTo",
	desktopWrapper: ".left-header",
	desktopMethod: "appendTo",
	breakpoint: 1025
}).watch();

function priceSliderInit() {
	var sliderOption = {
		range: true,
		min: 0,
		max: 30000,
		values: [0, 30000],
		step: 10,
		slide: function( event, ui ) {
			$( ".price-display .min-price" ).text( ui.values[0] + "$ ");
			$( ".price-display .max-price" ).text( ui.values[1] + "$");
		}
	}
	$( ".price-slider" ).slider(sliderOption);

	$('.price-reset').click(function(e){
		e.preventDefault()
		$( ".price-slider" ).slider("values", 0, sliderOption.values[0])
		$( ".price-slider" ).slider("values", 1, sliderOption.values[1] )
		$( ".price-display .min-price" ).text( sliderOption.values[0] + "$ ");
		$( ".price-display .max-price" ).text( sliderOption.values[1] + "$");
	})
}

function flashSaleCountdownInit() {
	$('.flash-countdown').each(function() {
		var date = $(this).data('date')
		var formatDate = moment(date,'DD/MM/YYYY HH:mm:ss').format('MM/DD/YYYY HH:mm:ss')
		$(this).countdown(formatDate, function(event) {
			$(this).html(event.strftime('%-D days %H : %M : %S'));
		});
	})
}

function adjustProductAmount() {
	$('.btn-dec').click(function(e) {
		e.preventDefault()
		let amountInput = $('.input-amount .amount')
		let amountVal = parseInt(amountInput.val())
		if (amountVal <= 0) {
			amountVal = 0;
		} else {
			amountVal--
		}
		amountInput.val(amountVal)
	})

	$('.btn-inc').click(function(e) {
		e.preventDefault()
		let amountInput = $('.input-amount .amount')
		let amountVal = parseInt(amountInput.val())
		amountVal ++;
		amountInput.val(amountVal)
	})


	$('.quantity .minus').click(function(e) {
		e.preventDefault()
		let amountInput = $(this).next()
		let amountVal = parseInt(amountInput.val())
		if (amountVal <= 0) {
			amountVal = 0;
		} else {
			amountVal--
		}
		amountInput.val(amountVal)
		amountInput.trigger('change')
	})

	$('.quantity .plus').click(function(e) {
		e.preventDefault()
		let amountInput = $(this).prev()
		let amountVal = parseInt(amountInput.val())
		amountVal ++;
		amountInput.val(amountVal)
		amountInput.trigger('change')
	})

}

function ajaxLinkClick() {
	$('.manual-zone-title a').click(function(e){
		e.preventDefault()
		$(this).parent().siblings().removeClass('active')
		$(this).parent().addClass('active')
		let pageurl = $(this).attr('href')
		$.ajax(
			{ 
				url: pageurl, 
				data: { isajax: true }, 
				success: function (data) {
					$('.support-detail').html($(data));
				}
		})
	})
}